import WorkerApiService from "../workerApiServices";


class TipoProdutoService extends WorkerApiService {

    constructor(endpoint_url) {
        super(endpoint_url || '/api/tipoProduto');
    }

    search(){
        return this.get(`/search`)
    }

    save(tipoDeProduto){
        return this.post(`/save`, tipoDeProduto)
    }

    buscaTiposProdutosCMV(){
        return this.get(`/buscaTiposProdutosCMV`)
    }


}


export default TipoProdutoService